module.exports = __webpack_public_path__ + "static/media/score_heatmap_2.d34ab2e8.png";